import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import http from "../../../../services/http.service";
import { toast } from "react-toastify";
import { apiPageLimit } from "../../../../constants/common";

const AUDIT_TRAIL = `/audit-trail`;
const EXPORT_AUDIT_TRAIL = `/audit-trail/report`;


export const getAuditTrailList = createAsyncThunk(
  "getAuditTrailList",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page = 1, limit = apiPageLimit, search = "", property = "", role = "", action = "", start_date = "", end_date = "", owner_uuid = "" } = values;
      const response = await http.get(`${AUDIT_TRAIL}?page=${page}&limit=${limit}&search=${search}&property=${property}&role=${role}&action=${action}&start_date=${start_date}&end_date=${end_date}&owner_id=${owner_uuid}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const exportAuditTrail = createAsyncThunk(
  "exportAuditTrail",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { owner_uuid = "" } = values;
      const response = await http.get(`${EXPORT_AUDIT_TRAIL}?owner_uuid=${owner_uuid}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);